import { useEffect, useState } from "react";

import { getChannelProfile } from "../services/channelProfileService";

export function useChannelProfile(username) {
  const [creator, setCreator] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    setCreator(null);
    setError(null);

    if (!username) {
      setLoading(false);
      return;
    }

    const fetchProfile = async () => {
      setLoading(true);

      try {
        const response = await getChannelProfile(username);

        if (!active) return;

        const data = response?.data || {};

        setCreator(
          data.creator ||
            data.channel ||
            (data.success === false ? null : data) ||
            null,
        );
      } catch (error) {
        if (!active) return;

        console.error("Unable to load channel profile:", error);
        setCreator(null);
        setError(
          error.response?.data?.message || "Unable to load channel profile.",
        );
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchProfile();

    return () => {
      active = false;
    };
  }, [username]);

  return {
    creator,
    loading,
    error,
  };
}
